import { yupResolver } from '@hookform/resolvers/yup';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { Fab } from '@mui/material';
import { Box } from '@mui/system';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { FormTextField } from '../../common/form';
import { CreateProductGroupDto, ProductGroupDto } from '../../common/PricePrgClient';
import { createProductGroup, deleteProductGroup, updateProductGroup } from '../product/redux/productSlices';
import { showConfirmDialog } from '../ui/redux/uiSlices';
type Props = {
    productGroup: ProductGroupDto;
    disabled: boolean;
};

const schema: yup.SchemaOf<CreateProductGroupDto> = yup.object().shape({
    name: yup.string().required().max(60).label('Name'),
    externalIdentifier: yup.string().optional().max(40).label('External identifier')
});
export const ProductGroupRow = ({ productGroup, disabled }: Props) => {
    const dispatch = useDispatch();
    const { handleSubmit, control } = useForm<CreateProductGroupDto>({
        resolver: yupResolver(schema),
        defaultValues: { ...productGroup, externalIdentifier: productGroup.externalIdentifier ?? undefined }
    });

    const onSubmit = (request: CreateProductGroupDto) => {
        if (!productGroup.productGroupId) {
            dispatch(createProductGroup.request(request));
        } else {
            dispatch(updateProductGroup.request({ ...request, productGroupId: productGroup.productGroupId }));
        }
    };

    const handleDelete = () => {
        dispatch(
            showConfirmDialog({
                dialogMessage: 'Do you want to delete the product group?',
                dialogTitle: 'Delete product group',
                okAction: deleteProductGroup.request(productGroup.productGroupId),
                primaryActionName: 'Delete'
            })
        );
    };

    return (
        <Box>
            <FormTextField
                sx={{ padding: 1 }}
                label="Name"
                control={control}
                name="name"
                disabled={disabled}
            />
            <FormTextField
                sx={{ padding: 1 }}
                control={control}
                name="externalIdentifier"
                disabled={disabled}
                label="External Id"
            />

            <Fab
                sx={{ mt: 2 }}
                size="small"
                color="primary"
                disabled={disabled}
                onClick={handleSubmit(onSubmit)}
            >
                <SaveIcon />
            </Fab>
            <Fab sx={{ mt: 2 }} size="small" color="error" onClick={handleDelete} disabled={disabled}>
                <DeleteIcon />
            </Fab>
        </Box>
    );
};
